import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './index.css';

type Service = {
  service: string;
  price: string;
};

type CategoryConfig = {
  id: string;
  titleKey: string;
  dataKey: string;
  subtitleKeys?: string[];
};

const CATEGORIES: CategoryConfig[] = [
  { id: 'general',      titleKey: 'pricing.categories.general.title',      dataKey: 'pricing.general' },
  { id: 'filling',      titleKey: 'pricing.categories.fillings.title',     dataKey: 'pricing.fillings',     subtitleKeys: ['pricing.categories.fillings.subtitle'] },
  { id: 'canal',        titleKey: 'pricing.categories.root.title',         dataKey: 'pricing.root',         subtitleKeys: ['pricing.categories.root.subtitle'] },
  { id: 'surgery',      titleKey: 'pricing.categories.surgery.title',      dataKey: 'pricing.surgery',      subtitleKeys: ['pricing.categories.surgery.subtitle'] },
  { id: 'implantation', titleKey: 'pricing.categories.implantology.title', dataKey: 'pricing.implantology', subtitleKeys: ['pricing.categories.implantology.subtitle', 'pricing.categories.implantology.subtitle_two'] },
  { id: 'prosthetics',  titleKey: 'pricing.categories.prosthetics.title',  dataKey: 'pricing.prosthetics' },
  { id: 'hygiene',      titleKey: 'pricing.categories.hygiene.title',      dataKey: 'pricing.hygiene',      subtitleKeys: ['pricing.categories.hygiene.subtitle'] },
  { id: 'straightening',titleKey: 'pricing.categories.aligners.title',     dataKey: 'pricing.aligners',     subtitleKeys: ['pricing.categories.aligners.subtitle'] },
  { id: 'children',     titleKey: 'pricing.categories.children.title',     dataKey: 'pricing.children',     subtitleKeys: ['pricing.categories.children.subtitle'] },
];

export const Pricing = () => {
  const { t } = useTranslation();
  const [activeId, setActiveId] = useState(CATEGORIES[0].id);

  const active = CATEGORIES.find((c) => c.id === activeId) ?? CATEGORIES[0];
  const rows = t(active.dataKey, { returnObjects: true }) as Service[];

  return (
    <div className="pricing-container">
      <div className="pricing-header">
        <h1 className="pricing-title">{t('pricing.title')}</h1>
        <p className="pricing-subtitle">{t('pricing.effectiveFrom')}</p>
      </div>

      <div className="category-tabs" role="tablist" aria-label="Pricing categories">
        {CATEGORIES.map(({ id, titleKey }) => (
          <button
            key={id}
            role="tab"
            aria-selected={activeId === id}
            className={`tab-btn ${activeId === id ? 'tab-btn--active' : ''}`}
            onClick={() => setActiveId(id)}
          >
            {t(titleKey)}
          </button>
        ))}
      </div>

      <div className="pricing-panel" role="tabpanel" key={activeId}>
        <div className="panel-header">
          <h2 className="panel-title">{t(active.titleKey)}</h2>
          {active.subtitleKeys?.map((sk) => (
            <p key={sk} className="panel-subtitle">{t(sk)}</p>
          ))}
        </div>

        <table className="pricing-table">
          <tbody>
            {Array.isArray(rows) &&
              rows.map((item, idx) => (
                <tr key={idx} className={idx % 2 === 0 ? 'row-even' : 'row-odd'}>
                  <td className="service-name">{item.service}</td>
                  <td className="service-price">{item.price}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
